import authAntiFraud from './authAntiFraud';
import authBonus from './authBonus';
import authCard from './authCard';
import authEmail from './authEmail';
import authGlobalSend from './authGlobalSend';
import authKyc from './authKyc';
import authProfile from './authProfile';
import authRequest from './authRequest';
import authSend from './authSend';
import deepLinkAuth from './deepLinkAuth';
import gaAccountTopUp from './gaAccountTopUp';
import gaAuth from './gaAuth';
import gaAuthCard from './gaAuthCard';
import gaExchange from './gaExchange';
import gaSend from './gaSend';
import registration from './registration';

let routes = [];

routes = routes.concat(
    gaAccountTopUp,
    gaAuthCard,
    gaSend,
    authGlobalSend,
    gaExchange,
    gaAuth,
    authAntiFraud,
    authSend,
    authRequest,
    authBonus,
    authCard,
    authProfile,
    authEmail,
    authKyc,
    registration,
    deepLinkAuth,
);

export default routes;
